module.exports = function() {
	return new Worker(__webpack_public_path__ + "98e323a3a9ee673c9e25.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/worker-loader!./browser/library/js/workers/pm-web-worker.js
 ** module id = 486
 ** module chunks = 1
 **/